// Module
var code = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 14 8\"> <path fill=\"#343941\" d=\"M13.3594 4.21875L9.69531 7.88281V4.89062H0.734375V3.53906H9.69531L9.70312 0.554688L13.3594 4.21875Z\"/> </svg>";
// Exports
module.exports = code;